import { cn } from '@core/utils';

import { calculateTaxDeduction } from '@/app/donation/guide/utils';
import { useCheckKakaobank } from '@/hooks/useCheckKakaobank';

const FULL_TAX_DEDUCTION_LIMIT = 100000;

interface PriceInfoProps {
  amount: number;
}

export const PriceInfo = ({ amount }: PriceInfoProps) => {
  const isKakaobank = useCheckKakaobank();
  const isFullTaxDeduction = amount <= FULL_TAX_DEDUCTION_LIMIT;

  if (!isFullTaxDeduction || isKakaobank) {
    return (
      <div>
        <p
          className={cn(
            'font-700 text-Gray-900 typo-h3',
            'tablet:typo-h5',
            'mobile:typo-h5',
          )}
        >
          {amount.toLocaleString()}원
        </p>
        <p
          className={cn(
            'font-500 text-B-500 typo-body3',
            'tablet:typo-body4',
            'mobile:typo-body4',
          )}
        >
          {isFullTaxDeduction
            ? `세액공제로 ${amount.toLocaleString()}원 모두 돌려받아요`
            : `세액공제로 ${calculateTaxDeduction(amount).total.toLocaleString()}원 돌려받아요`}
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center gap-8">
        <span
          className={cn(
            'font-700 text-Gray-550 line-through typo-body1',
            'tablet:typo-body2',
            'mobile:typo-body2',
          )}
        >
          {amount.toLocaleString()}원
        </span>
        <span
          className={cn(
            'font-700 text-O-400 typo-h3',
            'tablet:typo-h5',
            'mobile:typo-h5',
          )}
        >
          0원
        </span>
      </div>
      <p
        className={cn(
          'font-500 text-B-500 typo-body3',
          'tablet:typo-body4',
          'mobile:typo-body4',
        )}
      >
        세액공제로 {amount.toLocaleString()}원 모두 돌려받아요
      </p>
    </div>
  );
};
